import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const CreateInformacionGeneral = () => {

  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

    const [formData, setFormData] = useState({

    programa: "",
    contrato_convenio: "",
    tipo_cobertura: "",
    contratante: "",
    centro_costos: "",
    objeto: "",
    lugar_ejecucion: "",
    cobertura: "",
    fecha_inicio: "",
    fecha_fin: "",
    valor_contrato_antes_iva: "",
    plazo_pago: ""

    });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ======================================
  // INPUTS
  // ======================================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  // ======================================
  // SUBMIT
  // ======================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setError("");
    setSuccess("");

    // VALIDACIONES

    if (!formData.programa) {
      setError("Debe ingresar el programa");
      return;
    }

    if (!formData.contrato_convenio) {
      setError("Debe ingresar el contrato/convenio");
      return;
    }

    if (!formData.tipo_cobertura) {
      setError("Debe ingresar el tipo de cobertura");
      return;
    }

    if (!formData.contratante) {
      setError("Debe ingresar el contratante");
      return;
    }

    if (!formData.centro_costos) {
      setError("Debe ingresar el centro de costos");
      return;
    }

    if (!formData.objeto) {
      setError("Debe ingresar el objeto");
      return;
    }

    if (!formData.lugar_ejecucion) {
      setError("Debe ingresar el lugar de ejecución");
      return;
    }

    if (!formData.fecha_inicio || !formData.fecha_fin) {
      setError("Debe seleccionar las fechas");
      return;
    }

    try {

      const res = await authFetch(
        ENDPOINTS.createInformacionGeneral,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Información general creada correctamente");

      setTimeout(() => {

        navigate("/session/mod_administrativa/informacion_general/informacionGeneral");

      }, 1500);

    } catch (err) {

      console.error(err);
      setError("Error en el servidor");

    }

  };

  return (

    <div className="p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center m-3">

        <h3>Crear Información General</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() =>
            navigate("/session/mod_administrativa/informacion_general/informacion_general")
          }
        >
          <i className="bi bi-arrow-left me-1"></i>
          Volver
        </button>

      </div>

      {/* FORM */}

      <form
        className="card p-4 shadow-sm"
        onSubmit={handleSubmit}
      >

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        {/* FILA 1 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Programa *</label>

            <input
              type="number"
              name="programa"
              className="form-control"
              value={formData.programa}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Contrato / Convenio *</label>

            <input
              type="text"
              name="contrato_convenio"
              className="form-control"
              value={formData.contrato_convenio}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FILA 2 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Tipo cobertura *</label>

            <input
              type="text"
              name="tipo_cobertura"
              className="form-control"
              value={formData.tipo_cobertura}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FILA 3 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Contratante *</label>

            <input
              type="text"
              name="contratante"
              className="form-control"
              value={formData.contratante}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Centro de costos *</label>

            <input
              type="number"
              name="centro_costos"
              className="form-control"
              value={formData.centro_costos}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* OBJETO */}

        <div className="mb-3">

          <label>Objeto *</label>

          <textarea
            name="objeto"
            className="form-control"
            rows="3"
            value={formData.objeto}
            onChange={handleChange}
          />

        </div>

        {/* FILA 4 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Lugar de ejecución *</label>

            <input
              type="text"
              name="lugar_ejecucion"
              className="form-control"
              value={formData.lugar_ejecucion}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Cobertura *</label>

            <input
              type="number"
              name="cobertura"
              className="form-control"
              value={formData.cobertura}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FECHAS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Fecha inicio *</label>

            <input
              type="date"
              name="fecha_inicio"
              className="form-control"
              value={formData.fecha_inicio}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Fecha fin *</label>

            <input
              type="date"
              name="fecha_fin"
              className="form-control"
              value={formData.fecha_fin}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FILA 5 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Valor contrato antes IVA *</label>

            <input
              type="number"
              name="valor_contrato_antes_iva"
              className="form-control"
              value={formData.valor_contrato_antes_iva}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Plazo de pago *</label>

            <input
              type="text"
              name="plazo_pago"
              className="form-control"
              value={formData.plazo_pago}
              onChange={handleChange}
            />

          </div>

        </div>
        {/* BOTÓN */}

        <button
          type="submit"
          className="btn btn-outline-pink w-100 mt-4"
        >
          Crear información general
        </button>

      </form>

    </div>

  );

};

export default CreateInformacionGeneral;